import { useEffect, useState } from "react";

type MorphTransition = {
  isExpanded: boolean;
  isClosing: boolean;
  isOpening: boolean;
};

export const useMorphTransition = (isOpen: boolean, duration: number): MorphTransition => {
  const [prevIsOpen, setPrevIsOpen] = useState(isOpen);
  const [isClosing, setIsClosing] = useState(false);
  const [isOpening, setIsOpening] = useState(false);

  if (prevIsOpen !== isOpen) {
    setPrevIsOpen(isOpen);
    setIsClosing(!isOpen);
    setIsOpening(isOpen);
  }

  useEffect(() => {
    if (!isClosing) {
      return;
    }
    const timer = setTimeout(() => setIsClosing(false), duration);
    return () => clearTimeout(timer);
  }, [isClosing, duration]);

  useEffect(() => {
    if (!isOpening) {
      return;
    }
    const timer = setTimeout(() => setIsOpening(false), duration);
    return () => clearTimeout(timer);
  }, [isOpening, duration]);

  return {
    isExpanded: isOpen || isClosing,
    isClosing,
    isOpening
  };
};
